import { Box } from "@mui/material";
import UserAvatar from "./UserAvatar";

/**
 * Overlapping group of UserAvatars. Standard SaaS sharing-UI pattern.
 *
 * Props:
 *   users: [{ display_name, email, user_id, is_admin }]   (in display order)
 *   max: int — show this many; rest become a "+N" pill
 *   size: int — avatar diameter
 *   onClick: optional — click any avatar / +N pill
 */
export default function AvatarStack({ users = [], max = 4, size = 24, onClick }) {
  const visible = users.slice(0, max);
  const overflow = users.length - visible.length;

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={onClick}
    >
      {visible.map((u, i) => (
        <Box
          key={u.user_id || u.email || i}
          sx={{ ml: i === 0 ? 0 : `-${Math.floor(size / 3)}px`, zIndex: 10 - i }}
        >
          <UserAvatar user={u} size={size} />
        </Box>
      ))}
      {overflow > 0 && (
        <Box
          sx={{
            ml: `-${Math.floor(size / 3)}px`,
            width: size,
            height: size,
            borderRadius: "50%",
            bgcolor: "grey.300",
            color: "text.primary",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: Math.max(10, Math.floor(size * 0.42)),
            fontWeight: 600,
            border: "2px solid white",
          }}
        >
          +{overflow}
        </Box>
      )}
    </Box>
  );
}
